import format from 'date-fns/format';
import { parseISO } from 'date-fns/fp';
import { route } from 'preact-router';

import { Livechat, CustumApiClass } from '../api';
import { canRenderMessage } from '../components/helpers';
import I18n from '../i18n';
import store from '../store';
import constants from './constants';

export const loadConfig = async () => {
	const {
		token,
	} = store.state;

	Livechat.credentials.token = token;

	const {
		agent,
		room,
		guest: user,
		resources: { sound: src = null } = {},
		queueInfo,
		...config
	} = await Livechat.config({ token });
	const apiInstance = new CustumApiClass();
	const {data: { allSettings }} = await apiInstance.getWidgetSettings();
	if (allSettings && allSettings.primaryColor) {
		config.theme.color = allSettings.tertiaryColor;
		config.theme.primaryColor = allSettings.primaryColor;
		config.theme.gray = allSettings.quinaryColor;
		config.theme.title= allSettings.chatBotTitle;
	}
	const handelSession = () => {
		let timeOutScope = '';
		const setTimer = (socketConnection, {token, rid, tenantCode}) => {
			timeOutScope = setTimeout(() => {
				socketConnection.send(JSON.stringify({
					token,
					rid,
					type: "UPDATE_SESSION",
					tenantCode
				}));
				// await Livechat.closeChat({ rid });
				// localStorage.setItem('session', 'expired');
				// route('/chat-finished')
			 }, 3000);
		}
		const clearTimer = () => {
			if (timeOutScope) {
				localStorage.removeItem('session', 'expired');
				clearTimeout(timeOutScope);
			}
		}
		return { setTimer, clearTimer }
	}
	const connection = await apiInstance.connectToSocket();
	await store.setState({
		config,
		agent: agent && agent.hiddenInfo ? { hiddenInfo: true } : agent, // TODO: revert it when the API is updated
		room,
		user,
		queueInfo,
		sound: { src, enabled: true, play: false },
		messages: [],
		typing: [],
		noMoreMessages: false,
		visible: true,
		unread: null,
		handelSession: handelSession(),
		settings: allSettings,
		connection
	});
};

export const processUnread = async () => {
	const { minimized, visible, messages } = store.state;
	if (minimized || !visible) {
		const { alerts, lastReadMessageId } = store.state;
		const renderedMessages = messages.filter((message) => canRenderMessage(message));
		const lastReadMessageIndex = renderedMessages.findIndex((item) => item._id === lastReadMessageId);
		const unreadMessages = renderedMessages.slice(lastReadMessageIndex + 1);

		if (lastReadMessageIndex !== -1) {
			const lastReadMessage = renderedMessages[lastReadMessageIndex];
			const alertMessage = I18n.t({
				one: 'One new message since %{since}',
				other: '%{count} new messages since %{since}',
			}, {
				count: unreadMessages.length,
				since: format(parseISO(lastReadMessage.ts), 'HH:mm MMM dd'),
			});
			const alert = { id: constants.unreadMessagesAlertId, children: alertMessage, success: true, timeout: 0 };
			const newAlerts = alerts.filter((item) => item.id !== constants.unreadMessagesAlertId);
			await store.setState({ alerts: (newAlerts.push(alert), newAlerts) });
		}

		await store.setState({ unread: unreadMessages.length });
	}
};
